import * as React from "react";
import { classNames } from "src/utils/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", ...props }, ref) => {
    const baseStyles = "flex w-full bg-transparent";
    const borderStyles = "rounded-md border border-input";
    const paddingStyles = "py-1";
    const textStyles = "text-base md:text-sm";

    return (
      <input
        type={type}
        className={classNames(
          baseStyles,
          borderStyles,
          paddingStyles,
          textStyles,
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
